import 'tslib';
import * as Long from 'long';
import '../../proto/index.js';
import '../../core/consts.js';
import '../../core/metrics/logger.js';
import '../../core/metrics/monitor.js';
import '../../core/service/RuntimeContext.js';
import '../../core/network/NetworkItem.js';
import 'json-long';
import 'moize';
import { Message } from '../../core/model/Message.js';
import 'js-md5';
import '../../core/utils/lz4.js';
import '../../core/utils/serializer.js';
import '../../adapter/manager/AdapterManager.js';
import '../../adapter/manager/types.js';
import '../../core/utils/ticker.js';
import '../../adapter/abstract/IMNetApi.js';
import '../../core/options.js';
import '../../core/utils/uuid.js';
import '../../core/service/ConversationManager.js';
import '../../core/service/MessageManager.js';
import '@byted/uc-secure-sdk';
import '../../core/plugin/DbProxy.js';
import '../../core/metrics/trackerTypes.js';
import '../../core/model/CommandMessage.js';
import { MessageProperty } from '../../core/model/MessageProperty.js';

class MessageStore {
    static formatMessageKey(m) {
        return `${m.conversationId}:${m.clientId}`;
    }
    static convertPropertyStore(raw) {
        return raw.map(p => ({
            messageId: p.messageId,
            conversationId: p.conversationId,
            key: p.key,
            userId: p.userId,
            secUid: p.secUid,
            createTime: p.createTime,
            idempotentId: p.idempotentId,
            value: p.value,
            version: p.version.toString(),
            status: p.status
        }));
    }
    static fromPropertyStore(raw) {
        return raw.map(s => {
            const p = new MessageProperty();
            p.messageId = s.messageId;
            p.conversationId = s.conversationId;
            p.key = s.key;
            p.userId = s.userId;
            p.secUid = s.secUid;
            p.createTime = new Date(s.createTime); // 如果msg是解密得到的, createTime会是string，需要额外处理一步
            p.idempotentId = s.idempotentId;
            p.value = s.value;
            p.version = Long.fromValue(s.version);
            p.status = s.status;
            return p;
        });
    }
    static toStore(m) {
        var _a, _b;
        const s = new MessageStore();
        s.clientId = m.clientId;
        s.content = m.content;
        s.conversationId = m.conversationId;
        s.conversationShortId = m.conversationShortId;
        s.conversationType = m.conversationBizType;
        s.createdAt = m.createdAt;
        s.ext = m.ext;
        s.indexInConversation = m.indexInConversation.toString();
        s.orderInConversation = m.orderInConversation.toString();
        s.secSender = m.secSender;
        s.sender = m.sender;
        s.serverId = m.serverId;
        s.serverStatus = m.serverStatus;
        s.type = m.type;
        s.version = m.version.toString();
        s.property = {};
        s.isOffline = m.isOffline;
        s.source = m.source;
        if (typeof m.flightStatus === 'number') {
            s.flightStatus = m.flightStatus;
        }
        for (const key of Object.keys(m.property)) {
            s.property[key] = MessageStore.convertPropertyStore(m.property[key]);
        }
        if (typeof m.flightStatus === 'number') {
            s.flightStatus = m.flightStatus;
        }
        if (m.referenceInfo) {
            s.referenceInfo = {
                referenceMessageId: m.referenceInfo.referenced_message_id.toString(),
                hint: m.referenceInfo.hint,
                refMessageType: m.referenceInfo.ref_message_type.toString(),
                referenceMessageStatus: m.referenceInfo.referenced_message_status,
                rootMessageId: (_a = m.referenceInfo.root_message_id) === null || _a === void 0 ? void 0 : _a.toString(),
                rootMessageConvIndex: (_b = m.referenceInfo.root_message_conv_index) === null || _b === void 0 ? void 0 : _b.toString()
            };
        }
        return s;
    }
    static fromStore(ctx, s) {
        const m = new Message(ctx);
        m.clientId = s.clientId;
        m.content = s.content;
        m.conversationId = s.conversationId;
        m.conversationShortId = s.conversationShortId;
        m.conversationBizType = s.conversationType;
        m.createdAt = new Date(s.createdAt);
        m.ext = s.ext;
        m.indexInConversation = Long.fromValue(s.indexInConversation);
        m.orderInConversation = Long.fromValue(s.orderInConversation);
        m.secSender = s.secSender;
        m.sender = s.sender;
        m.serverId = s.serverId;
        m.serverStatus = s.serverStatus;
        m.type = s.type;
        m.version = Long.fromValue(s.version);
        m.isOffline = s.isOffline;
        m.source = s.source;
        if (typeof m.flightStatus === 'number') {
            s.flightStatus = m.flightStatus;
        }
        m.property = {};
        for (const key of Object.keys(s.property)) {
            m.property[key] = MessageStore.fromPropertyStore(s.property[key]);
        }
        if (typeof s.flightStatus === 'number') {
            m.flightStatus = s.flightStatus;
        }
        if (s.referenceInfo) {
            m.referenceInfo = {
                referenced_message_id: Long.fromValue(s.referenceInfo.referenceMessageId),
                hint: s.referenceInfo.hint,
                ref_message_type: Long.fromValue(s.referenceInfo.refMessageType),
                referenced_message_status: s.referenceInfo.referenceMessageStatus,
                root_message_id: s.referenceInfo.rootMessageId ? Long.fromValue(s.referenceInfo.rootMessageId) : undefined,
                root_message_conv_index: s.referenceInfo.rootMessageConvIndex ? Long.fromValue(s.referenceInfo.rootMessageConvIndex) : undefined
            };
        }
        return m;
    }
}

export { MessageStore };
//# sourceMappingURL=MessageStore.js.map
